import { useNavigate } from "react-router-dom";
import { Gift, LayoutGrid, Search, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useStore } from "@/context/StoreContext";

/** Sticky mobile bottom bar: Categories / Gifts / Under ₹10k / Search / Cart. */
export default function MobileTabBar() {
  const navigate = useNavigate();
  const { setSearchOpen } = useStore();
  const { count, setDrawerOpen } = useCart();

  const items = [
    { label: "Shop", icon: LayoutGrid, onClick: () => navigate("/shop"), testid: "tab-shop" },
    { label: "Gifts", icon: Gift, onClick: () => navigate("/gifts"), testid: "tab-gifts" },
    { label: "Under ₹10k", icon: null, text: "₹10k", onClick: () => navigate("/gifts/under-10000"), testid: "tab-under-10k" },
    { label: "Search", icon: Search, onClick: () => setSearchOpen(true), testid: "tab-search" },
    { label: "Cart", icon: ShoppingBag, onClick: () => setDrawerOpen(true), testid: "tab-cart", badge: count },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-brand text-ivory border-t border-gold/30" data-testid="mobile-tab-bar">
      <div className="grid grid-cols-5">
        {items.map(({ label, icon: Icon, text, onClick, testid, badge }) => (
          <button key={label} onClick={onClick} className="relative flex flex-col items-center gap-0.5 py-2.5 btn-press" data-testid={`mobile-${testid}`}>
            {Icon ? <Icon size={19} /> : <span className="text-[13px] font-semibold gold-num leading-[19px]">{text}</span>}
            <span className="text-[10px] tracking-wide">{label}</span>
            {badge > 0 && (
              <span className="absolute top-1 right-4 bg-gold text-brand text-[9px] font-bold rounded-full h-4 min-w-4 px-1 flex items-center justify-center">
                {badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
}
